"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e20) { throw _e20; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e21) { didErr = true; err = _e21; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    r = function r(e) {
  return e instanceof HTMLElement;
};

var t = "blur",
    n = "change",
    s = "input",
    c = "onBlur",
    u = "onChange",
    i = "onSubmit",
    a = "onTouched",
    o = "all",
    l = "max",
    f = "min",
    d = "maxLength",
    y = "minLength",
    g = "pattern",
    b = "required",
    m = "validate";

var h = function h(e) {
  return null == e;
};

var v = function v(e) {
  return "object" == typeof e;
};

var p = function p(e) {
  return !h(e) && !Array.isArray(e) && v(e) && !(e instanceof Date);
},
    O = function O(e) {
  return /^\w*$/.test(e);
},
    A = function A(e) {
  return e.filter(Boolean);
},
    R = function R(e) {
  return A(e.replace(/["|']/g, "").replace(/\[/g, ".").replace(/\]/g, "").split("."));
};

function V(e, r, t) {
  var n = -1;
  var s = O(r) ? [r] : R(r),
      c = s.length,
      u = c - 1;

  for (; ++n < c;) {
    var _r = s[n];
    var _c = t;

    if (n !== u) {
      var _t = e[_r];
      _c = p(_t) || Array.isArray(_t) ? _t : isNaN(+s[n + 1]) ? {} : [];
    }

    e[_r] = _c, e = e[_r];
  }

  return e;
}

var j = function j(e) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  for (var _t2 in e) {
    O(_t2) ? r[_t2] = e[_t2] : V(r, _t2, e[_t2]);
  }

  return r;
},
    F = function F(e) {
  return void 0 === e;
},
    C = function C() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var r = arguments.length > 1 ? arguments[1] : undefined;
  var t = arguments.length > 2 ? arguments[2] : undefined;
  var n = A(r.split(/[,[\].]+?/)).reduce(function (e, r) {
    return h(e) ? e : e[r];
  }, e);
  return F(n) || n === e ? F(e[r]) ? t : e[r] : n;
},
    x = function x(e, c) {
  r(e) && e.removeEventListener && (e.removeEventListener(s, c), e.removeEventListener(n, c), e.removeEventListener(t, c));
};

var k = {
  isValid: !1,
  value: null
};

var S = function S(e) {
  return Array.isArray(e) ? e.reduce(function (e, r) {
    return r && r.ref.checked ? {
      isValid: !0,
      value: r.ref.value
    } : e;
  }, k) : k;
},
    w = function w(e) {
  return "radio" === e.type;
},
    D = function D(e) {
  return "file" === e.type;
},
    E = function E(e) {
  return "checkbox" === e.type;
},
    B = function B(e) {
  return "select-multiple" === e.type;
};

var N = {
  value: !1,
  isValid: !1
},
    L = {
  value: !0,
  isValid: !0
};

var W = function W(e) {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      var _r3 = e.filter(function (e) {
        return e && e.ref.checked;
      }).map(function (_ref) {
        var e = _ref.ref.value;
        return e;
      });

      return {
        value: _r3,
        isValid: !!_r3.length
      };
    }

    var _e$0$ref = e[0].ref,
        _r2 = _e$0$ref.checked,
        _t3 = _e$0$ref.value,
        _n = _e$0$ref.attributes;
    return _r2 ? _n && !F(_n.value) ? F(_t3) || "" === _t3 ? L : {
      value: _t3,
      isValid: !0
    } : L : N;
  }

  return N;
};

function M(e, r, t, n, s) {
  var c = e.current[r];

  if (c) {
    var _c$ref = c.ref,
        _e2 = _c$ref.value,
        _r4 = _c$ref.disabled,
        _t4 = c.ref,
        _i = c.valueAsNumber,
        _a = c.valueAsDate,
        _o = c.setValueAs;
    if (_r4 && n) return;
    return D(_t4) ? _t4.files : w(_t4) ? S(c.options).value : B(_t4) ? (u = _t4.options, _toConsumableArray(u).filter(function (_ref2) {
      var e = _ref2.selected;
      return e;
    }).map(function (_ref3) {
      var e = _ref3.value;
      return e;
    })) : E(_t4) ? W(c.options).value : s ? _e2 : _i ? "" === _e2 ? NaN : +_e2 : _a ? _t4.valueAsDate : _o ? _o(_e2) : _e2;
  }

  var u;
  if (t) return C(t.current, r);
}

function T(e) {
  return !e || e instanceof HTMLElement && e.nodeType !== Node.DOCUMENT_NODE && T(e.parentNode);
}

var P = function P(e) {
  return p(e) && !Object.keys(e).length;
},
    $ = function $(e) {
  return "boolean" == typeof e;
};

function U(e, r) {
  var t = O(r) ? [r] : R(r),
      n = 1 == t.length ? e : function (e, r) {
    var t = r.slice(0, -1).length;
    var n = 0;

    for (; n < t;) {
      e = F(e) ? n++ : e[r[n++]];
    }

    return e;
  }(e, t),
      s = t[t.length - 1];
  var c;
  n && delete n[s];

  for (var _r5 = 0; _r5 < t.slice(0, -1).length; _r5++) {
    var _n2 = void 0,
        _s = -1;

    var _u = t.slice(0, -(_r5 + 1)),
        _i2 = _u.length - 1;

    for (_r5 > 0 && (c = e); ++_s < _u.length;) {
      var _r6 = _u[_s];
      _n2 = _n2 ? _n2[_r6] : e[_r6], _i2 === _s && (p(_n2) && P(_n2) || Array.isArray(_n2) && !_n2.filter(function (e) {
        return p(e) && !P(e) || $(e);
      }).length) && (c ? delete c[_r6] : delete e[_r6]), c = _n2;
    }
  }

  return e;
}

var q = function q(e, r) {
  return e && e.ref === r;
};

var H = function H(e) {
  return h(e) || !v(e);
};

function I(e, r) {
  if (H(e) || H(r)) return r;

  for (var _t5 in r) {
    var _n3 = e[_t5],
        _s2 = r[_t5];

    try {
      e[_t5] = p(_n3) && p(_s2) || Array.isArray(_n3) && Array.isArray(_s2) ? I(_n3, _s2) : _s2;
    } catch (e) {}
  }

  return e;
}

function _(r, t, n) {
  if (H(r) || H(t) || r instanceof Date || t instanceof Date) return r === t;

  if (!e.isValidElement(r)) {
    var _e3 = Object.keys(r),
        _s3 = Object.keys(t);

    if (_e3.length !== _s3.length) return !1;

    for (var _i3 = 0, _e4 = _e3; _i3 < _e4.length; _i3++) {
      var _s4 = _e4[_i3];
      var _e5 = r[_s4];

      if (!n || "ref" !== _s4) {
        var _r7 = t[_s4];
        if ((p(_e5) || Array.isArray(_e5)) && (p(_r7) || Array.isArray(_r7)) ? !_(_e5, _r7, n) : _e5 !== _r7) return !1;
      }
    }
  }

  return !0;
}

function z(e, r, t, n, s) {
  var c = -1;

  for (; ++c < e.length;) {
    for (var _n4 in e[c]) {
      Array.isArray(e[c][_n4]) ? (!t[c] && (t[c] = {}), t[c][_n4] = [], z(e[c][_n4], C(r[c] || {}, _n4, []), t[c][_n4], t[c], _n4)) : _(C(r[c] || {}, _n4), e[c][_n4]) ? V(t[c] || {}, _n4) : t[c] = Object.assign(Object.assign({}, t[c]), _defineProperty({}, _n4, !0));
    }

    n && !t.length && delete n[s];
  }

  return t;
}

var G = function G(e, r, t) {
  return I(z(e, r, t.slice(0, e.length)), z(r, e, t.slice(0, e.length)));
},
    J = function J(e) {
  return "string" == typeof e;
},
    K = function K(e, r, t, n, s) {
  var c = {};

  var _loop = function _loop(_r8) {
    (F(s) || (J(s) ? _r8.startsWith(s) : Array.isArray(s) && s.find(function (e) {
      return _r8.startsWith(e);
    }))) && (c[_r8] = M(e, _r8, void 0, n));
  };

  for (var _r8 in e.current) {
    _loop(_r8);
  }

  return t ? j(c) : I(r, j(c));
},
    Q = function Q(e) {
  return e instanceof RegExp;
},
    X = function X(e) {
  return p(e) && !Q(e) ? e : {
    value: e,
    message: ""
  };
},
    Y = function Y(e) {
  return "function" == typeof e;
},
    Z = function Z(r) {
  return J(r) || e.isValidElement(r);
};

function ee(e, r) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "validate";
  if (Z(e) || $(e) && !e) return {
    type: t,
    message: Z(e) ? e : "",
    ref: r
  };
}

var re = function re(e, r, t, n, s) {
  return r ? Object.assign(Object.assign({}, t[e]), {
    types: Object.assign(Object.assign({}, t[e] && t[e].types ? t[e].types : {}), _defineProperty({}, n, s || !0))
  }) : {};
},
    te = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, r, _ref4, A) {
    var t, n, s, c, u, i, a, o, v, O, R, V, j, F, C, x, k, D, _ref6, _n5, _s5, _e6, _s6, _c2, _u2, _r9, _r10, _e7, _t6, _s7, _c3, _X, _e8, _s8, _n6, _c4, _e9, _e10, _i4, _Object$entries, _Object$entries$_i, _t7, _s9, _u3;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            t = _ref4.ref, n = _ref4.ref.value, s = _ref4.options, c = _ref4.required, u = _ref4.maxLength, i = _ref4.minLength, a = _ref4.min, o = _ref4.max, v = _ref4.pattern, O = _ref4.validate;
            R = t.name, V = {}, j = w(t), F = E(t), C = j || F, x = "" === n, k = re.bind(null, R, r, V), D = function D(e, r, n) {
              var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : d;
              var c = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : y;
              var u = e ? r : n;
              V[R] = Object.assign({
                type: e ? s : c,
                message: u,
                ref: t
              }, k(e ? s : c, u));
            };

            if (!(c && (!j && !F && (x || h(n)) || $(n) && !n || F && !W(s).isValid || j && !S(s).isValid))) {
              _context.next = 6;
              break;
            }

            _ref6 = Z(c) ? {
              value: !!c,
              message: c
            } : X(c), _n5 = _ref6.value, _s5 = _ref6.message;

            if (!(_n5 && (V[R] = Object.assign({
              type: b,
              message: _s5,
              ref: C ? ((e.current[R].options || [])[0] || {}).ref : t
            }, k(b, _s5)), !r))) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", V);

          case 6:
            if (h(a) && h(o) || "" === n) {
              _context.next = 11;
              break;
            }

            _c2 = X(o), _u2 = X(a);

            if (isNaN(n)) {
              _r9 = t.valueAsDate || new Date(n);
              J(_c2.value) && (_e6 = _r9 > new Date(_c2.value)), J(_u2.value) && (_s6 = _r9 < new Date(_u2.value));
            } else {
              _r10 = t.valueAsNumber || parseFloat(n);
              h(_c2.value) || (_e6 = _r10 > _c2.value), h(_u2.value) || (_s6 = _r10 < _u2.value);
            }

            if (!((_e6 || _s6) && (D(!!_e6, _c2.message, _u2.message, l, f), !r))) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", V);

          case 11:
            if (!(J(n) && !x && (u || i))) {
              _context.next = 15;
              break;
            }

            _e7 = X(u), _t6 = X(i), _s7 = !h(_e7.value) && n.length > _e7.value, _c3 = !h(_t6.value) && n.length < _t6.value;

            if (!((_s7 || _c3) && (D(_s7, _e7.message, _t6.message), !r))) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", V);

          case 15:
            if (!(J(n) && v && !x)) {
              _context.next = 19;
              break;
            }

            _X = X(v), _e8 = _X.value, _s8 = _X.message;

            if (!(Q(_e8) && !_e8.test(n) && (V[R] = Object.assign({
              type: g,
              message: _s8,
              ref: t
            }, k(g, _s8)), !r))) {
              _context.next = 19;
              break;
            }

            return _context.abrupt("return", V);

          case 19:
            if (!O) {
              _context.next = 52;
              break;
            }

            _n6 = M(e, R, A, !1, !0), _c4 = C && s ? s[0].ref : t;

            if (!Y(O)) {
              _context.next = 32;
              break;
            }

            _context.t0 = ee;
            _context.next = 25;
            return O(_n6);

          case 25:
            _context.t1 = _context.sent;
            _context.t2 = _c4;
            _e9 = (0, _context.t0)(_context.t1, _context.t2);

            if (!(_e9 && (V[R] = Object.assign(Object.assign({}, _e9), k(m, _e9.message)), !r))) {
              _context.next = 30;
              break;
            }

            return _context.abrupt("return", V);

          case 30:
            _context.next = 52;
            break;

          case 32:
            if (!p(O)) {
              _context.next = 52;
              break;
            }

            _e10 = {};
            _i4 = 0, _Object$entries = Object.entries(O);

          case 35:
            if (!(_i4 < _Object$entries.length)) {
              _context.next = 50;
              break;
            }

            _Object$entries$_i = _slicedToArray(_Object$entries[_i4], 2), _t7 = _Object$entries$_i[0], _s9 = _Object$entries$_i[1];

            if (!(!P(_e10) && !r)) {
              _context.next = 39;
              break;
            }

            return _context.abrupt("break", 50);

          case 39:
            _context.t3 = ee;
            _context.next = 42;
            return _s9(_n6);

          case 42:
            _context.t4 = _context.sent;
            _context.t5 = _c4;
            _context.t6 = _t7;
            _u3 = (0, _context.t3)(_context.t4, _context.t5, _context.t6);
            _u3 && (_e10 = Object.assign(Object.assign({}, _u3), k(_t7, _u3.message)), r && (V[R] = _e10));

          case 47:
            _i4++;
            _context.next = 35;
            break;

          case 50:
            if (!(!P(_e10) && (V[R] = Object.assign({
              ref: _c4
            }, _e10), !r))) {
              _context.next = 52;
              break;
            }

            return _context.abrupt("return", V);

          case 52:
            return _context.abrupt("return", V);

          case 53:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function te(_x, _x2, _x3, _x4) {
    return _ref5.apply(this, arguments);
  };
}();

var ne = function ne(e, r) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  for (var _n7 in r) {
    var _s10 = e + (p(r) ? "." + _n7 : "[".concat(_n7, "]"));

    H(r[_n7]) ? t.push(_s10) : ne(_s10, r[_n7], t);
  }

  return t;
};

var se = function se(e, r, t, n, s) {
  var c = void 0;
  return t.add(r), P(e) || (c = C(e, r), (p(c) || Array.isArray(c)) && ne(r, c).forEach(function (e) {
    return t.add(e);
  })), F(c) ? s ? n : C(n, r) : c;
},
    ce = function ce(_ref7) {
  var e = _ref7.isOnBlur,
      r = _ref7.isOnChange,
      t = _ref7.isOnTouch,
      n = _ref7.isTouched,
      s = _ref7.isReValidateOnBlur,
      c = _ref7.isReValidateOnChange,
      u = _ref7.isBlurEvent,
      i = _ref7.isSubmitted,
      a = _ref7.isOnAll;
  return !a && (!i && t ? !(n || u) : (i ? s : e) ? !u : !(i ? c : r) || u);
},
    ue = function ue(e) {
  return e.substring(0, e.indexOf("["));
};

var ie = function ie(e, r) {
  return RegExp("^".concat(r, "([|.)\\d+").replace(/\[/g, "\\[").replace(/\]/g, "\\]")).test(e);
};

var ae = function ae(e, r) {
  return _toConsumableArray(e).some(function (e) {
    return ie(r, e);
  });
};

var oe = "undefined" != typeof window && "undefined" != typeof document;

function le(e) {
  var t;
  var n;
  if (H(e) || oe && (e instanceof File || r(e))) return e;
  if (!["Set", "Map", "Object", "Date", "Array"].includes(null === (t = e.constructor) || void 0 === t ? void 0 : t.name)) return e;
  if (e instanceof Date) return n = new Date(e.getTime()), n;

  if (e instanceof Set) {
    n = new Set();

    var _iterator = _createForOfIteratorHelper(e),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _r11 = _step.value;
        n.add(_r11);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return n;
  }

  if (e instanceof Map) {
    n = new Map();

    var _iterator2 = _createForOfIteratorHelper(e.keys()),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _r12 = _step2.value;
        n.set(_r12, le(e.get(_r12)));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return n;
  }

  n = Array.isArray(e) ? [] : {};

  for (var _r13 in e) {
    n[_r13] = le(e[_r13]);
  }

  return n;
}

var fe = function fe(e) {
  return {
    isOnSubmit: !e || e === i,
    isOnBlur: e === c,
    isOnChange: e === u,
    isOnAll: e === o,
    isOnTouch: e === a
  };
},
    de = function de(e) {
  return w(e) || E(e);
};

var ye = "undefined" == typeof window,
    ge = oe ? "Proxy" in window : "undefined" != typeof Proxy;

function be(e, r) {
  var t = {};

  for (var n in e) {
    Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var s = 0;

    for (n = Object.getOwnPropertySymbols(e); s < n.length; s++) {
      r.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[s]) && (t[n[s]] = e[n[s]]);
    }
  }

  return t;
}

var me = e.createContext(null);
me.displayName = "RHFContext";

var he = function he() {
  return e.useContext(me);
};

var ve = function ve() {
  var e = "undefined" == typeof performance ? Date.now() : 1e3 * performance.now();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (r) {
    var t = (16 * Math.random() + e) % 16 | 0;
    return ("x" == r ? t : 3 & t | 8).toString(16);
  });
};

var pe = function pe(e, r) {
  return F(r) ? [] : function (e, r) {
    var t = 0;

    var n = _toConsumableArray(e);

    var _iterator3 = _createForOfIteratorHelper(r),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _e11 = _step3.value;
        n.splice(_e11 - t, 1), t++;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return A(n).length ? n : [];
  }(e, (Array.isArray(r) ? r : [r]).sort(function (e, r) {
    return e - r;
  }));
},
    Oe = function Oe(e, r, t) {
  return Array.isArray(e) ? (F(e[t]) && (e[t] = void 0), e.splice(t, 0, e.splice(r, 1)[0]), e) : [];
},
    Ae = function Ae(e, r, t) {
  var n = [e[t], e[r]];
  e[r] = n[0], e[t] = n[1];
};

function Re(e, r) {
  return [].concat(_toConsumableArray(Array.isArray(r) ? r : [r || void 0]), _toConsumableArray(e));
}

function Ve(e, r, t) {
  return [].concat(_toConsumableArray(e.slice(0, r)), _toConsumableArray(Array.isArray(t) ? t : [t || void 0]), _toConsumableArray(e.slice(r)));
}

var je = function je(e) {
  return Array.isArray(e) ? Array(e.length).fill(void 0) : void 0;
},
    Fe = function Fe(e) {
  return (Array.isArray(e) ? e : [e]).map(function (e) {
    if (p(e)) {
      var _r14 = {};

      for (var _t8 in e) {
        _r14[_t8] = !0;
      }

      return _r14;
    }

    return !0;
  });
};

var Ce = function Ce() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var r = arguments.length > 1 ? arguments[1] : undefined;
  var t = arguments.length > 2 ? arguments[2] : undefined;
  return e.map(function (e) {
    return Object.assign(_defineProperty({}, r, e[r] || ve()), e);
  });
};

function xe(_ref8) {
  var r = _ref8.name,
      t = _ref8.rules,
      n = _ref8.defaultValue,
      s = _ref8.control,
      c = _ref8.onFocus;

  var u = he(),
      _ref9 = s || u.control,
      i = _ref9.defaultValuesRef,
      a = _ref9.setValue,
      o = _ref9.register,
      l = _ref9.unregister,
      f = _ref9.trigger,
      d = _ref9.mode,
      _ref9$reValidateMode = _ref9.reValidateMode,
      y = _ref9$reValidateMode.isReValidateOnBlur,
      g = _ref9$reValidateMode.isReValidateOnChange,
      b = _ref9.formState,
      _ref9$formStateRef$cu = _ref9.formStateRef.current,
      m = _ref9$formStateRef$cu.isSubmitted,
      h = _ref9$formStateRef$cu.touched,
      v = _ref9$formStateRef$cu.errors,
      O = _ref9.updateFormState,
      A = _ref9.readFormStateRef,
      R = _ref9.fieldsRef,
      j = _ref9.fieldArrayNamesRef,
      x = _ref9.shallowFieldsStateRef,
      k = !ae(j.current, r),
      S = function S() {
    return !F(C(x.current, r)) && k ? C(x.current, r) : F(n) ? C(i.current, r) : n;
  },
      _e$useState = e.useState(S()),
      _e$useState2 = _slicedToArray(_e$useState, 2),
      w = _e$useState2[0],
      D = _e$useState2[1],
      E = e.useRef(w),
      B = e.useRef({
    focus: function focus() {
      return null;
    }
  }),
      N = e.useRef(c || function () {
    Y(B.current.focus) && B.current.focus();
  }),
      L = e.useCallback(function (e) {
    return !ce(Object.assign({
      isBlurEvent: e,
      isReValidateOnBlur: y,
      isReValidateOnChange: g,
      isSubmitted: m,
      isTouched: !!C(h, r)
    }, d));
  }, [y, g, m, h, r, d]),
      W = e.useCallback(function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 1),
        e = _ref11[0];

    var r = function (e) {
      return H(e) || !p(e.target) || p(e.target) && !e.type ? e : F(e.target.value) ? e.target.checked : e.target.value;
    }(e);

    return D(r), E.current = r, r;
  }, []),
      M = e.useCallback(function (e) {
    R.current[r] ? R.current[r] = Object.assign({
      ref: R.current[r].ref
    }, t) : (o(Object.defineProperties({
      name: r,
      focus: N.current
    }, {
      value: {
        set: function set(e) {
          D(e), E.current = e;
        },
        get: function get() {
          return E.current;
        }
      }
    }), t), e = F(C(i.current, r))), e && k && D(S());
  }, [t, r, o]);

  e.useEffect(function () {
    return function () {
      return l(r);
    };
  }, [r]), e.useEffect(function () {
    M();
  }, [M]), e.useEffect(function () {
    !R.current[r] && M(!0);
  });
  var T = e.useCallback(function () {
    A.current.touched && !C(h, r) && (V(h, r, !0), O({
      touched: h
    })), L(!0) && f(r);
  }, [r, O, L, f, A]);
  return {
    field: {
      onChange: e.useCallback(function () {
        for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
          e[_key] = arguments[_key];
        }

        return a(r, W(e), {
          shouldValidate: L(),
          shouldDirty: !0
        });
      }, [a, r, L]),
      onBlur: T,
      name: r,
      value: w,
      ref: B
    },
    meta: Object.defineProperties({
      invalid: !!C(v, r)
    }, {
      isDirty: {
        get: function get() {
          return !!C(b.dirtyFields, r);
        }
      },
      isTouched: {
        get: function get() {
          return !!C(b.touched, r);
        }
      }
    })
  };
}

exports.Controller = function (r) {
  var t = r.rules,
      n = r.as,
      s = r.render,
      c = r.defaultValue,
      u = r.control,
      i = r.onFocus,
      a = be(r, ["rules", "as", "render", "defaultValue", "control", "onFocus"]),
      _xe = xe(r),
      o = _xe.field,
      l = _xe.meta,
      f = Object.assign(Object.assign({}, a), o);

  return n ? e.isValidElement(n) ? e.cloneElement(n, f) : e.createElement(n, f) : s ? s(o, l) : null;
}, exports.FormProvider = function (r) {
  var t = r.children,
      n = be(r, ["children"]);
  return e.createElement(me.Provider, {
    value: Object.assign({}, n)
  }, t);
}, exports.appendErrors = re, exports.get = C, exports.transformToNestObject = j, exports.useController = xe, exports.useFieldArray = function (_ref12) {
  var r = _ref12.control,
      t = _ref12.name,
      _ref12$keyName = _ref12.keyName,
      n = _ref12$keyName === void 0 ? "id" : _ref12$keyName;

  var s = he(),
      c = e.useRef(-1),
      u = e.useRef(!1),
      _ref13 = r || s.control,
      i = _ref13.isFormDirty,
      a = _ref13.updateWatchedValue,
      o = _ref13.resetFieldArrayFunctionRef,
      l = _ref13.fieldArrayNamesRef,
      f = _ref13.fieldsRef,
      d = _ref13.defaultValuesRef,
      y = _ref13.removeFieldEventListener,
      g = _ref13.formStateRef,
      b = _ref13.shallowFieldsStateRef,
      m = _ref13.updateFormState,
      h = _ref13.readFormStateRef,
      v = _ref13.validFieldsRef,
      p = _ref13.fieldsWithValidationRef,
      O = _ref13.fieldArrayDefaultValuesRef,
      R = _ref13.validateResolver,
      j = _ref13.getValues,
      F = _ref13.shouldUnregister,
      x = _ref13.fieldArrayValuesRef,
      k = function k(e) {
    return C(F ? e : b.current, t, []);
  },
      S = ue(t),
      w = e.useRef(_toConsumableArray(C(O.current, S) ? k(O.current) : k(d.current))),
      _e$useState3 = e.useState(Ce(w.current, n)),
      _e$useState4 = _slicedToArray(_e$useState3, 2),
      D = _e$useState4[0],
      E = _e$useState4[1];

  V(x.current, t, A(D));

  var B = function B(e) {
    return e.map(function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var r = n;
      e[r];
      return be(e, ["symbol" == typeof r ? r : r + ""]);
    });
  };

  l.current.add(t);

  var N = e.useCallback(function () {
    return C(x.current, t, []);
  }, [t]),
      L = function L() {
    return Ce(C(j(), t, N()).map(function (e, r) {
      return Object.assign(Object.assign({}, N()[r]), e);
    }), n);
  };

  l.current.add(t), S && !C(O.current, S) && V(O.current, S, le(C(d.current, S)));

  var W = function W(e) {
    if (E(e), V(x.current, t, e), h.current.isValid && R) {
      var _r15 = j();

      V(_r15, t, e), R(_r15);
    }
  },
      M = function M() {
    for (var _e12 in f.current) {
      ie(_e12, t) && (y(f.current[_e12], !0), delete f.current[_e12]);
    }
  },
      T = function T(e) {
    return !A(C(e, t, [])).length && U(e, t);
  },
      P = function P(e) {
    e && V(g.current.dirtyFields, t, G(B(e), C(d.current, t, []), C(g.current.dirtyFields, t, [])));
  },
      $ = function $(e, r, n) {
    var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var c = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
    var a = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;

    if (C(b.current, t)) {
      var _n8 = e(C(b.current, t), r.argA, r.argB);

      c && V(b.current, t, _n8);
    }

    if (C(O.current, t)) {
      var _n9 = e(C(O.current, t), r.argA, r.argB);

      c && V(O.current, t, _n9);
    }

    if (Array.isArray(C(g.current.errors, t))) {
      var _n10 = e(C(g.current.errors, t), r.argA, r.argB);

      c && V(g.current.errors, t, _n10), T(g.current.errors);
    }

    if (h.current.touched && C(g.current.touched, t)) {
      var _n11 = e(C(g.current.touched, t), r.argA, r.argB);

      c && V(g.current.touched, t, _n11), T(g.current.touched);
    }

    (h.current.dirtyFields || h.current.isDirty) && (V(g.current.dirtyFields, t, G(B(s), C(d.current, t, []), C(g.current.dirtyFields, t, []))), P(n), T(g.current.dirtyFields)), a && h.current.isValid && !R && (V(v.current, t, e(C(v.current, t, []), r.argA)), T(v.current), V(p.current, t, e(C(p.current, t, []), r.argA)), T(p.current)), !u.current && h.current.isDirty && m({
      isDirty: i(t, B(s))
    });
  },
      q = function q(e) {
    var r = L(),
        t = pe(r, e);
    W(t), M(), $(pe, {
      argA: e,
      argC: e
    }, t, pe(r, e), !0, !0);
  };

  return e.useEffect(function () {
    var e = C(O.current, t);
    if (e && D.length < e.length && V(O.current, t, e.slice(1)), a(t), c.current > -1) for (var _e13 in f.current) {
      var _r16 = f.current[_e13];

      if (_e13.startsWith("".concat(t, "[").concat(c.current, "]")) && _r16.ref.focus) {
        _r16.ref.focus();

        break;
      }
    }
    c.current = -1;
  }, [D, t]), e.useEffect(function () {
    var e = o.current,
        r = l.current;
    return ue(t) || (e[t] = function (e) {
      M(), !e && U(O.current, t), U(b.current, t), w.current = C(e || d.current, t), u.current || E(Ce(w.current, n));
    }), function () {
      u.current = !0, F && q(), M(), delete e[t], U(x.current, t), r.delete(t);
    };
  }, []), {
    swap: e.useCallback(function (e, r) {
      var t = L();
      Ae(t, e, r), M(), W(_toConsumableArray(t)), $(Ae, {
        argA: e,
        argB: r,
        argC: e,
        argD: r
      }, void 0, t, !1);
    }, [t]),
    move: e.useCallback(function (e, r) {
      var t = L();
      Oe(t, e, r), M(), W(_toConsumableArray(t)), $(Oe, {
        argA: e,
        argB: r,
        argC: e,
        argD: r
      }, void 0, t, !1);
    }, [t]),
    prepend: e.useCallback(function (e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var t = je(e),
          s = Re(L(), Ce(Array.isArray(e) ? e : [e], n));
      W(s), M(), $(Re, {
        argA: t,
        argC: Fe(e)
      }, s), c.current = r ? 0 : -1;
    }, [t]),
    append: e.useCallback(function (e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var s = Array.isArray(e) ? e : [e],
          u = [].concat(_toConsumableArray(L()), _toConsumableArray(Ce(s, n)));
      W(u), (h.current.dirtyFields || h.current.isDirty) && (P(u), m({
        isDirty: !0,
        dirtyFields: g.current.dirtyFields
      })), !F && V(b.current, t, [].concat(_toConsumableArray(C(b.current, t) || []), _toConsumableArray(le(s)))), c.current = r ? C(x.current, t).length - 1 : -1;
    }, [t]),
    remove: e.useCallback(q, [t]),
    insert: e.useCallback(function (e, r) {
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var s = je(r),
          u = L(),
          i = Ve(u, e, Ce(Array.isArray(r) ? r : [r], n));
      W(i), M(), $(Ve, {
        argA: e,
        argB: s,
        argC: e,
        argD: Fe(r)
      }, i, Ve(u, e)), c.current = t ? e : -1;
    }, [t]),
    fields: A(D)
  };
}, exports.useForm = function () {
  var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref14$mode = _ref14.mode,
      c = _ref14$mode === void 0 ? i : _ref14$mode,
      _ref14$reValidateMode = _ref14.reValidateMode,
      a = _ref14$reValidateMode === void 0 ? u : _ref14$reValidateMode,
      l = _ref14.resolver,
      f = _ref14.context,
      _ref14$defaultValues = _ref14.defaultValues,
      d = _ref14$defaultValues === void 0 ? {} : _ref14$defaultValues,
      _ref14$shouldFocusErr = _ref14.shouldFocusError,
      y = _ref14$shouldFocusErr === void 0 ? !0 : _ref14$shouldFocusErr,
      _ref14$shouldUnregist = _ref14.shouldUnregister,
      g = _ref14$shouldUnregist === void 0 ? !0 : _ref14$shouldUnregist,
      b = _ref14.criteriaMode;

  var m = e.useRef({}),
      v = e.useRef({}),
      R = e.useRef({}),
      k = e.useRef(new Set()),
      S = e.useRef({}),
      N = e.useRef({}),
      L = e.useRef({}),
      W = e.useRef({}),
      $ = e.useRef(d),
      I = e.useRef(!1),
      z = e.useRef(!1),
      Q = e.useRef(),
      X = e.useRef({}),
      Z = e.useRef({}),
      ee = e.useRef(f),
      re = e.useRef(l),
      ie = e.useRef(new Set()),
      be = e.useRef(fe(c)),
      _be$current = be.current,
      me = _be$current.isOnSubmit,
      he = _be$current.isOnTouch,
      ve = b === o,
      _e$useState5 = e.useState({
    isDirty: !1,
    isValidating: !1,
    dirtyFields: {},
    isSubmitted: !1,
    submitCount: 0,
    touched: {},
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !me,
    errors: {}
  }),
      _e$useState6 = _slicedToArray(_e$useState5, 2),
      pe = _e$useState6[0],
      Oe = _e$useState6[1],
      Ae = e.useRef({
    isDirty: !ge,
    dirtyFields: !ge,
    touched: !ge || he,
    isValidating: !ge,
    isSubmitting: !ge,
    isValid: !ge
  }),
      Re = e.useRef(pe),
      Ve = e.useRef(),
      _e$useRef$current = e.useRef(fe(a)).current,
      je = _e$useRef$current.isOnBlur,
      Fe = _e$useRef$current.isOnChange;

  ee.current = f, re.current = l, Re.current = pe, X.current = g ? {} : P(X.current) ? le(d) : X.current;

  var Ce = e.useCallback(function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    I.current || (Re.current = Object.assign(Object.assign({}, Re.current), e), Oe(Re.current));
  }, []),
      xe = function xe() {
    return Ae.current.isValidating && Ce({
      isValidating: !0
    });
  },
      ke = e.useCallback(function (e, r) {
    var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var s = arguments.length > 4 ? arguments[4] : undefined;

    var c = t || function (_ref15) {
      var e = _ref15.errors,
          r = _ref15.name,
          t = _ref15.error,
          n = _ref15.validFields,
          s = _ref15.fieldsWithValidation;
      var c = F(t),
          u = C(e, r);
      return c && !!u || !c && !_(u, t, !0) || c && C(s, r) && !C(n, r);
    }({
      errors: Re.current.errors,
      error: r,
      name: e,
      validFields: W.current,
      fieldsWithValidation: L.current
    });

    var u = C(Re.current.errors, e);
    r ? (U(W.current, e), c = c || !u || !_(u, r, !0), V(Re.current.errors, e, r)) : ((C(L.current, e) || re.current) && (V(W.current, e, !0), c = c || u), U(Re.current.errors, e)), (c && !h(t) || !P(n) || Ae.current.isValidating) && Ce(Object.assign(Object.assign(Object.assign({}, n), re.current ? {
      isValid: !!s
    } : {}), {
      isValidating: !1
    }));
  }, []),
      Se = e.useCallback(function (e, t) {
    var _m$current$e = m.current[e],
        n = _m$current$e.ref,
        s = _m$current$e.options,
        c = oe && r(n) && h(t) ? "" : t;
    w(n) ? (s || []).forEach(function (_ref16) {
      var e = _ref16.ref;
      return e.checked = e.value === c;
    }) : D(n) && !J(c) ? n.files = c : B(n) ? _toConsumableArray(n.options).forEach(function (e) {
      return e.selected = c.includes(e.value);
    }) : E(n) && s ? s.length > 1 ? s.forEach(function (_ref17) {
      var e = _ref17.ref;
      return e.checked = Array.isArray(c) ? !!c.find(function (r) {
        return r === e.value;
      }) : c === e.value;
    }) : s[0].ref.checked = !!c : n.value = c;
  }, []),
      we = e.useCallback(function (e, r) {
    if (Ae.current.isDirty) {
      var _t9 = $e();

      return e && r && V(_t9, e, r), !_(_t9, $.current);
    }

    return !1;
  }, []),
      De = e.useCallback(function (e) {
    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;

    if (Ae.current.isDirty || Ae.current.dirtyFields) {
      var _t10 = !_(C($.current, e), M(m, e, X)),
          _n12 = C(Re.current.dirtyFields, e),
          _s11 = Re.current.isDirty;

      _t10 ? V(Re.current.dirtyFields, e, !0) : U(Re.current.dirtyFields, e);

      var _c5 = {
        isDirty: we(),
        dirtyFields: Re.current.dirtyFields
      },
          _u4 = Ae.current.isDirty && _s11 !== _c5.isDirty || Ae.current.dirtyFields && _n12 !== C(Re.current.dirtyFields, e);

      return _u4 && r && Ce(_c5), _u4 ? _c5 : {};
    }

    return {};
  }, []),
      Ee = e.useCallback( /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, r) {
      var t;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return te(m, ve, m.current[e], X);

            case 2:
              _context2.t0 = e;
              t = _context2.sent[_context2.t0];
              return _context2.abrupt("return", (ke(e, t, r), F(t)));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x5, _x6) {
      return _ref18.apply(this, arguments);
    };
  }(), [ke, ve]),
      Be = e.useCallback( /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
      var _yield$re$current, r, t, _t11, _n13;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return re.current($e(), ee.current, ve);

            case 2:
              _yield$re$current = _context3.sent;
              r = _yield$re$current.errors;
              t = Re.current.isValid;

              if (!Array.isArray(e)) {
                _context3.next = 8;
                break;
              }

              _t11 = e.map(function (e) {
                var t = C(r, e);
                return t ? V(Re.current.errors, e, t) : U(Re.current.errors, e), !t;
              }).every(Boolean);
              return _context3.abrupt("return", (Ce({
                isValid: P(r),
                isValidating: !1
              }), _t11));

            case 8:
              _n13 = C(r, e);
              return _context3.abrupt("return", (ke(e, _n13, t !== P(r), {}, P(r)), !_n13));

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x7) {
      return _ref19.apply(this, arguments);
    };
  }(), [ke, ve]),
      Ne = e.useCallback( /*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e) {
      var r, _t12;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              r = e || Object.keys(m.current);

              if (!(xe(), re.current)) {
                _context5.next = 3;
                break;
              }

              return _context5.abrupt("return", Be(r));

            case 3:
              if (!Array.isArray(r)) {
                _context5.next = 9;
                break;
              }

              !e && (Re.current.errors = {});
              _context5.next = 7;
              return Promise.all(r.map( /*#__PURE__*/function () {
                var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e) {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return Ee(e, null);

                        case 2:
                          return _context4.abrupt("return", _context4.sent);

                        case 3:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                return function (_x9) {
                  return _ref21.apply(this, arguments);
                };
              }()));

            case 7:
              _t12 = _context5.sent;
              return _context5.abrupt("return", (Ce({
                isValidating: !1
              }), _t12.every(Boolean)));

            case 9:
              _context5.next = 11;
              return Ee(r);

            case 11:
              return _context5.abrupt("return", _context5.sent);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x8) {
      return _ref20.apply(this, arguments);
    };
  }(), [Be, Ee]),
      Le = e.useCallback(function (e, r, _ref22) {
    var t = _ref22.shouldDirty,
        n = _ref22.shouldValidate;
    var s = {};
    V(s, e, r);

    var _iterator4 = _createForOfIteratorHelper(ne(e, r)),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _c6 = _step4.value;
        m.current[_c6] && (Se(_c6, C(s, _c6)), t && De(_c6), n && Ne(_c6));
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }, [Ne, Se, De]),
      We = e.useCallback(function (e, r, t) {
    if (!g && !H(r) && V(X.current, e, Array.isArray(r) ? _toConsumableArray(r) : Object.assign({}, r)), m.current[e]) Se(e, r), t.shouldDirty && De(e), t.shouldValidate && Ne(e);else if (!H(r) && (Le(e, r, t), ie.current.has(e))) {
      var _n14 = ue(e) || e;

      V(v.current, e, r), Z.current[_n14](_defineProperty({}, _n14, C(v.current, _n14))), (Ae.current.isDirty || Ae.current.dirtyFields) && t.shouldDirty && (V(Re.current.dirtyFields, e, G(r, C($.current, e, []), C(Re.current.dirtyFields, e, []))), Ce({
        isDirty: !_(Object.assign(Object.assign({}, $e()), _defineProperty({}, e, r)), $.current)
      }));
    }
    !g && V(X.current, e, r);
  }, [De, Se, Le]),
      Me = function Me(e) {
    return z.current || k.current.has(e) || k.current.has((e.match(/\w+/) || [])[0]);
  },
      Te = function Te(e) {
    var r = !0;
    if (!P(S.current)) for (var _t13 in S.current) {
      e && S.current[_t13].size && !S.current[_t13].has(e) && !S.current[_t13].has(ue(e)) || (N.current[_t13](), r = !1);
    }
    return r;
  };

  function Pe(e) {
    if (!g) {
      var _r17 = le(e);

      var _iterator5 = _createForOfIteratorHelper(ie.current),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _e14 = _step5.value;
          O(_e14) && !_r17[_e14] && (_r17 = Object.assign(Object.assign({}, _r17), _defineProperty({}, _e14, [])));
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return _r17;
    }

    return e;
  }

  function $e(e) {
    if (J(e)) return M(m, e, X);

    if (Array.isArray(e)) {
      var _r18 = {};

      var _iterator6 = _createForOfIteratorHelper(e),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _t14 = _step6.value;
          V(_r18, _t14, M(m, _t14, X));
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return _r18;
    }

    return Pe(K(m, le(X.current), g));
  }

  Q.current = Q.current ? Q.current : /*#__PURE__*/function () {
    var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref23) {
      var e, r, n, s, c, u, _i5, _a2, _o2, _l, _yield$re$current2, _e15, _t15, _r19, _t16;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              e = _ref23.type, r = _ref23.target;
              n = r.name;
              s = m.current[n];

              if (!s) {
                _context6.next = 23;
                break;
              }

              _i5 = e === t, _a2 = ce(Object.assign({
                isBlurEvent: _i5,
                isReValidateOnChange: Fe,
                isReValidateOnBlur: je,
                isTouched: !!C(Re.current.touched, n),
                isSubmitted: Re.current.isSubmitted
              }, be.current));
              _o2 = De(n, !1), _l = !P(_o2) || !_i5 && Me(n);

              if (!(_i5 && !C(Re.current.touched, n) && Ae.current.touched && (V(Re.current.touched, n, !0), _o2 = Object.assign(Object.assign({}, _o2), {
                touched: Re.current.touched
              })), !g && E(r) && V(X.current, n, M(m, n)), _a2)) {
                _context6.next = 8;
                break;
              }

              return _context6.abrupt("return", (!_i5 && Te(n), (!P(_o2) || _l && P(_o2)) && Ce(_o2)));

            case 8:
              if (!(xe(), re.current)) {
                _context6.next = 18;
                break;
              }

              _context6.next = 11;
              return re.current($e(), ee.current, ve);

            case 11:
              _yield$re$current2 = _context6.sent;
              _e15 = _yield$re$current2.errors;
              _t15 = Re.current.isValid;

              if (c = C(_e15, n), E(r) && !c && re.current) {
                _r19 = ue(n), _t16 = C(_e15, _r19, {});
                _t16.type && _t16.message && (c = _t16), _r19 && (_t16 || C(Re.current.errors, _r19)) && (n = _r19);
              }

              u = P(_e15), _t15 !== u && (_l = !0);
              _context6.next = 22;
              break;

            case 18:
              _context6.next = 20;
              return te(m, ve, s, X);

            case 20:
              _context6.t0 = n;
              c = _context6.sent[_context6.t0];

            case 22:
              !_i5 && Te(n), ke(n, c, _l, _o2, u);

            case 23:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x10) {
      return _ref24.apply(this, arguments);
    };
  }();

  var Ue = e.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var e,
        r,
        _ref26,
        t,
        n,
        _args7 = arguments;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            e = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
            r = P(m.current) ? $.current : {};
            _context7.next = 4;
            return re.current(Object.assign(Object.assign(Object.assign({}, r), $e()), e), ee.current, ve);

          case 4:
            _context7.t0 = _context7.sent;

            if (_context7.t0) {
              _context7.next = 7;
              break;
            }

            _context7.t0 = {};

          case 7:
            _ref26 = _context7.t0;
            t = _ref26.errors;
            n = P(t);
            Re.current.isValid !== n && Ce({
              isValid: n
            });

          case 11:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  })), [ve]),
      qe = e.useCallback(function (e, r) {
    !function (e, r, t, n, s, c) {
      var u = t.ref,
          i = t.ref.name,
          a = e.current[i];

      if (!s) {
        var _r20 = M(e, i, n);

        !F(_r20) && V(n.current, i, _r20);
      }

      u.type && a ? w(u) || E(u) ? Array.isArray(a.options) && a.options.length ? (A(a.options).forEach(function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t = arguments.length > 1 ? arguments[1] : undefined;
        (T(e.ref) && q(e, e.ref) || c) && (x(e.ref, r), U(a.options, "[".concat(t, "]")));
      }), a.options && !A(a.options).length && delete e.current[i]) : delete e.current[i] : (T(u) && q(a, u) || c) && (x(u, r), delete e.current[i]) : delete e.current[i];
    }(m, Q.current, e, X, g, r), g && (U(W.current, e.ref.name), U(L.current, e.ref.name));
  }, [g]),
      He = e.useCallback(function (e) {
    if (z.current) Ce();else {
      var _iterator7 = _createForOfIteratorHelper(k.current),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _r21 = _step7.value;

          if (_r21.startsWith(e)) {
            Ce();
            break;
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      Te(e);
    }
  }, []),
      Ie = e.useCallback(function (e, r) {
    e && (qe(e, r), g && !A(e.options || []).length && (U(Re.current.errors, e.ref.name), V(Re.current.dirtyFields, e.ref.name, !0), Ce({
      isDirty: we()
    }), Ae.current.isValid && re.current && Ue(), He(e.ref.name)));
  }, [Ue, qe]),
      _e = e.useCallback(function (e, r, t) {
    var n = t ? S.current[t] : k.current;
    var s = K(m, le(X.current), g, !1, e);

    if (J(e)) {
      var _t17 = ue(e) || e;

      return ie.current.has(_t17) && (s = Object.assign(Object.assign({}, R.current), s)), se(s, e, n, F(C($.current, e)) ? r : C($.current, e), !0);
    }

    var c = F(r) ? $.current : r;
    return Array.isArray(e) ? e.reduce(function (e, r) {
      return Object.assign(Object.assign({}, e), _defineProperty({}, r, se(s, r, n, c)));
    }, {}) : (z.current = F(t), j(!P(s) && s || c));
  }, []);

  function ze(e) {
    var c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var u = e.name,
        i = e.type,
        a = e.value,
        o = Object.assign({
      ref: e
    }, c),
        l = m.current,
        f = de(e),
        d = ae(ie.current, u),
        y = function y(t) {
      return oe && (!r(e) || t === e);
    };

    var b,
        h = l[u],
        v = !0;
    if (h && (f ? Array.isArray(h.options) && A(h.options).find(function (e) {
      return a === e.ref.value && y(e.ref);
    }) : y(h.ref))) return void (l[u] = Object.assign(Object.assign({}, h), c));
    h = i ? f ? Object.assign({
      options: [].concat(_toConsumableArray(A(h && h.options || [])), [{
        ref: e
      }]),
      ref: {
        type: i,
        name: u
      }
    }, c) : Object.assign({}, o) : o, l[u] = h;
    var p = F(C(X.current, u));
    P($.current) && p || (b = C(p ? $.current : X.current, u), v = F(b), v || d || Se(u, b)), P(c) || (V(L.current, u, !0), !me && Ae.current.isValid && te(m, ve, h, X).then(function (e) {
      var r = Re.current.isValid;
      P(e) ? V(W.current, u, !0) : U(W.current, u), r !== P(e) && Ce();
    })), !g || d && v || !d && U(Re.current.dirtyFields, u), i && function (_ref27, c, u) {
      var e = _ref27.ref;
      r(e) && u && (e.addEventListener(c ? n : s, u), e.addEventListener(t, u));
    }(f && h.options ? h.options[h.options.length - 1] : h, f || "select-one" === e.type, Q.current);
  }

  var Ge = e.useCallback(function (e, r) {
    return /*#__PURE__*/function () {
      var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(t) {
        var n, s, _yield$re$current3, _e16, _r22, _i6, _Object$values, _e17, _r23, _t18;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                t && t.preventDefault && (t.preventDefault(), t.persist());
                n = {}, s = Pe(K(m, le(X.current), g, !0));
                Ae.current.isSubmitting && Ce({
                  isSubmitting: !0
                });
                _context8.prev = 3;

                if (!re.current) {
                  _context8.next = 13;
                  break;
                }

                _context8.next = 7;
                return re.current(s, ee.current, ve);

              case 7:
                _yield$re$current3 = _context8.sent;
                _e16 = _yield$re$current3.errors;
                _r22 = _yield$re$current3.values;
                Re.current.errors = n = _e16, s = _r22;
                _context8.next = 25;
                break;

              case 13:
                _i6 = 0, _Object$values = Object.values(m.current);

              case 14:
                if (!(_i6 < _Object$values.length)) {
                  _context8.next = 25;
                  break;
                }

                _e17 = _Object$values[_i6];

                if (!_e17) {
                  _context8.next = 22;
                  break;
                }

                _r23 = _e17.ref.name;
                _context8.next = 20;
                return te(m, ve, _e17, X);

              case 20:
                _t18 = _context8.sent;
                _t18[_r23] ? (V(n, _r23, _t18[_r23]), U(W.current, _r23)) : C(L.current, _r23) && (U(Re.current.errors, _r23), V(W.current, _r23, !0));

              case 22:
                _i6++;
                _context8.next = 14;
                break;

              case 25:
                if (!(P(n) && Object.keys(Re.current.errors).every(function (e) {
                  return e in m.current;
                }))) {
                  _context8.next = 31;
                  break;
                }

                Ce({
                  errors: {},
                  isSubmitting: !0
                });
                _context8.next = 29;
                return e(s, t);

              case 29:
                _context8.next = 37;
                break;

              case 31:
                Re.current.errors = Object.assign(Object.assign({}, Re.current.errors), n);
                _context8.t0 = r;

                if (!_context8.t0) {
                  _context8.next = 36;
                  break;
                }

                _context8.next = 36;
                return r(Re.current.errors, t);

              case 36:
                y && function (e, r) {
                  for (var _t19 in e) {
                    if (C(r, _t19)) {
                      var _r24 = e[_t19];

                      if (_r24) {
                        if (_r24.ref.focus && F(_r24.ref.focus())) break;

                        if (_r24.options) {
                          _r24.options[0].ref.focus();

                          break;
                        }
                      }
                    }
                  }
                }(m.current, Re.current.errors);

              case 37:
                _context8.prev = 37;
                Re.current.isSubmitting = !1, Ce({
                  isSubmitted: !0,
                  isSubmitting: !1,
                  isSubmitSuccessful: P(Re.current.errors),
                  submitCount: Re.current.submitCount + 1
                });
                return _context8.finish(37);

              case 40:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[3,, 37, 40]]);
      }));

      return function (_x11) {
        return _ref28.apply(this, arguments);
      };
    }();
  }, [y, ve]);
  e.useEffect(function () {
    l && Ae.current.isValid && Ue(), Ve.current = Ve.current || !oe ? Ve.current : function (e, r) {
      var t = new MutationObserver(function () {
        for (var _i7 = 0, _Object$values2 = Object.values(e.current); _i7 < _Object$values2.length; _i7++) {
          var _t20 = _Object$values2[_i7];

          if (_t20 && _t20.options) {
            var _iterator8 = _createForOfIteratorHelper(_t20.options),
                _step8;

            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var _e18 = _step8.value;
                _e18 && _e18.ref && T(_e18.ref) && r(_t20);
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
          } else _t20 && T(_t20.ref) && r(_t20);
        }
      });
      return t.observe(window.document, {
        childList: !0,
        subtree: !0
      }), t;
    }(m, Ie);
  }, [Ie, $.current]), e.useEffect(function () {
    return function () {
      Ve.current && Ve.current.disconnect(), I.current = !0, Object.values(m.current).forEach(function (e) {
        return Ie(e, !0);
      });
    };
  }, []), !l && Ae.current.isValid && (pe.isValid = _(W.current, L.current) && P(Re.current.errors));
  var Je = {
    trigger: Ne,
    setValue: e.useCallback(function (e, r, t) {
      We(e, r, t || {}), Me(e) && Ce(), Te(e);
    }, [We, Ne]),
    getValues: e.useCallback($e, []),
    register: e.useCallback(function (e, r) {
      if (!ye) if (J(e)) ze({
        name: e
      }, r);else {
        if (!p(e) || !("name" in e)) return function (r) {
          return r && ze(r, e);
        };
        ze(e, r);
      }
    }, [$.current]),
    unregister: e.useCallback(function (e) {
      var _iterator9 = _createForOfIteratorHelper(Array.isArray(e) ? e : [e]),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _r25 = _step9.value;
          Ie(m.current[_r25], !0);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }, []),
    formState: ge ? new Proxy(pe, {
      get: function get(e, r) {
        if (r in e) return Ae.current[r] = !0, e[r];
      }
    }) : pe
  },
      Ke = e.useMemo(function () {
    return Object.assign({
      isFormDirty: we,
      updateWatchedValue: He,
      shouldUnregister: g,
      updateFormState: Ce,
      removeFieldEventListener: qe,
      watchInternal: _e,
      mode: be.current,
      reValidateMode: {
        isReValidateOnBlur: je,
        isReValidateOnChange: Fe
      },
      validateResolver: l ? Ue : void 0,
      fieldsRef: m,
      resetFieldArrayFunctionRef: Z,
      useWatchFieldsRef: S,
      useWatchRenderFunctionsRef: N,
      fieldArrayDefaultValuesRef: v,
      validFieldsRef: W,
      fieldsWithValidationRef: L,
      fieldArrayNamesRef: ie,
      readFormStateRef: Ae,
      formStateRef: Re,
      defaultValuesRef: $,
      shallowFieldsStateRef: X,
      fieldArrayValuesRef: R
    }, Je);
  }, [$.current, He, g, qe, _e]);
  return Object.assign({
    watch: function watch(e, r) {
      return _e(e, r);
    },
    control: Ke,
    handleSubmit: Ge,
    reset: e.useCallback(function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (oe) for (var _i8 = 0, _Object$values3 = Object.values(m.current); _i8 < _Object$values3.length; _i8++) {
        var _e19 = _Object$values3[_i8];

        if (_e19) {
          var _t21 = _e19.ref,
              _n15 = _e19.options,
              _s12 = de(_t21) && Array.isArray(_n15) ? _n15[0].ref : _t21;

          if (r(_s12)) try {
            _s12.closest("form").reset();

            break;
          } catch (e) {}
        }
      }
      m.current = {}, $.current = Object.assign({}, e || $.current), e && Te(""), Object.values(Z.current).forEach(function (e) {
        return Y(e) && e();
      }), X.current = g ? {} : le(e || $.current), function (_ref29) {
        var e = _ref29.errors,
            r = _ref29.isDirty,
            t = _ref29.isSubmitted,
            n = _ref29.touched,
            s = _ref29.isValid,
            c = _ref29.submitCount,
            u = _ref29.dirtyFields;
        s || (W.current = {}, L.current = {}), v.current = {}, k.current = new Set(), z.current = !1, Ce({
          submitCount: c ? Re.current.submitCount : 0,
          isDirty: !!r && Re.current.isDirty,
          isSubmitted: !!t && Re.current.isSubmitted,
          isValid: !!s && Re.current.isValid,
          dirtyFields: u ? Re.current.dirtyFields : {},
          touched: n ? Re.current.touched : {},
          errors: e ? Re.current.errors : {},
          isSubmitting: !1,
          isSubmitSuccessful: !1
        });
      }(t);
    }, []),
    clearErrors: e.useCallback(function (e) {
      e && (Array.isArray(e) ? e : [e]).forEach(function (e) {
        return m.current[e] && O(e) ? delete Re.current.errors[e] : U(Re.current.errors, e);
      }), Ce({
        errors: e ? Re.current.errors : {}
      });
    }, []),
    setError: e.useCallback(function (e, r) {
      var t = (m.current[e] || {}).ref;
      V(Re.current.errors, e, Object.assign(Object.assign({}, r), {
        ref: t
      })), Ce({
        isValid: !1
      }), r.shouldFocus && t && t.focus && t.focus();
    }, []),
    errors: pe.errors
  }, Je);
}, exports.useFormContext = he, exports.useWatch = function (_ref30) {
  var r = _ref30.control,
      t = _ref30.name,
      n = _ref30.defaultValue;

  var s = he(),
      _ref31 = r || s.control,
      c = _ref31.useWatchFieldsRef,
      u = _ref31.useWatchRenderFunctionsRef,
      i = _ref31.watchInternal,
      a = _ref31.defaultValuesRef,
      o = e.useState()[1],
      l = e.useRef(),
      f = e.useRef(n);

  return e.useEffect(function () {
    var e = l.current = ve(),
        r = u.current,
        n = c.current;
    return n[e] = new Set(), r[e] = function () {
      return o({});
    }, i(t, f.current, e), function () {
      delete n[e], delete r[e];
    };
  }, [t, u, c, i, f]), l.current ? i(t, f.current, l.current) : F(n) ? J(t) ? C(a.current, t) : Array.isArray(t) ? t.reduce(function (e, r) {
    return Object.assign(Object.assign({}, e), _defineProperty({}, r, C(a.current, r)));
  }, {}) : a.current : n;
};